(function () {
  const atcBar = document.getElementById('sticky-atc');
  if (!atcBar) return;

  const productData = JSON.parse(document.getElementById('sticky-atc-product-json').textContent);
  const variants = productData.variants;

  let selectedOptions = {};
  let currentQty = 1;

  // 初始化选中状态
  const firstVariant = variants[0];
  if (firstVariant.option1) selectedOptions[1] = firstVariant.option1;
  if (firstVariant.option2) selectedOptions[2] = firstVariant.option2;
  if (firstVariant.option3) selectedOptions[3] = firstVariant.option3;

  function findVariant() {
    return variants.find(function (v) {
      return (
        (!selectedOptions[1] || v.option1 === selectedOptions[1]) &&
        (!selectedOptions[2] || v.option2 === selectedOptions[2]) &&
        (!selectedOptions[3] || v.option3 === selectedOptions[3])
      );
    });
  }

  function updateVariant() {
    const variant = findVariant();
    if (!variant) return;

    // 更新variant id
    document.getElementById('sticky-atc-variant-id').value = variant.id;

    // 更新图片
    if (variant.image) {
      document.getElementById('sticky-atc-image').src = variant.image;
    }

    // 更新按钮状态
    const btn = atcBar.querySelector('.sticky-atc__btn');
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  }

// 下拉选择
atcBar.querySelectorAll('.sticky-atc__select').forEach(function (select) {
  select.addEventListener('change', function () {
    const index = parseInt(this.dataset.optionIndex);
    selectedOptions[index] = this.value;
    updateVariant();
  });
});

  // 数量控制
  document.getElementById('sticky-atc-minus').addEventListener('click', function () {
    if (currentQty > 1) {
      currentQty--;
      document.getElementById('sticky-atc-qty').value = currentQty;
      document.getElementById('sticky-atc-qty-input').value = currentQty;
    }
  });

  document.getElementById('sticky-atc-plus').addEventListener('click', function () {
    currentQty++;
    document.getElementById('sticky-atc-qty').value = currentQty;
    document.getElementById('sticky-atc-qty-input').value = currentQty;
  });

  // 滚动显示/隐藏
  function onScroll() {
    if (window.scrollY > 400) {
      atcBar.classList.add('is-visible');
      atcBar.setAttribute('aria-hidden', 'false');
    } else {
      atcBar.classList.remove('is-visible');
      atcBar.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // 同步主页面variant变化
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    document.getElementById('sticky-atc-variant-id').value = variant.id;
    if (variant.featured_image) {
      document.getElementById('sticky-atc-image').src = variant.featured_image.src;
    }
  });
})();
